module.exports = __webpack_public_path__ + "img/leamosLogo.8564e0e0.svg";